export default __webpack_public_path__ + "static/media/Titelbild-NEU-alpinblau-Webseite-scaled.140391bf.jpg";